import React from 'react';
import { connect } from 'react-redux';
import { UncontrolledTooltip, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-duotone-svg-icons';

class SidebarControl extends React.PureComponent {
  handleClick = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'TOGGLE_SIDEBAR' });
  };

  render() {
    const { isOpen } = this.props;

    return (
      <>
        <div className="icon-group py-2">
          <Button
            id="sidebar-control"
            color={isOpen ? 'dark' : 'darker'}
            className="text-white p-2"
            onClick={this.handleClick}
          >
            <FontAwesomeIcon
              icon={faChevronRight}
              fixedWidth
              size="2x"
              flip={isOpen ? 'horizontal' : null}
              style={{ transition: 'all .3s ease' }}
            />
          </Button>
        </div>
        <UncontrolledTooltip target="sidebar-control" placement="right">
          {isOpen ? 'Collapse' : 'Expand'}
        </UncontrolledTooltip>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.modals.sidebarOpen,
});

export default connect(mapStateToProps)(SidebarControl);
